<div class="po-wrapper">
  <po-page-default>
    <div class="po-row">
      <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <p class="po-font-title">Pack de itens </p>
      </div>
    </div>
    <po-widget class="po-lg-12 po-mb-1">
      <div class="po-row po-pb-1" style="border-bottom: 1px solid #d3d3d3;">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <span class="po-text-color-01 po-font-text-large-bold">Capa do Pack</span>
        </div>
      </div>
      <app-scanner (scannedData)="updatePackInfo($event)"></app-scanner>
    </po-widget>
  </po-page-default>
</div>
<app-toaster></app-toaster>